import { createContext, useContext } from 'react';

export const TransitionStageContext = createContext('fadeIn');

export const useTransitionStage = () => {
  return useContext(TransitionStageContext);
};
